/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-07-02",
    versionChannel: "nightly",
    buildDate: "2023-07-02T00:20:03.951Z",
    commitHash: "bd043c09c7a4526d569da2ec5ea22695366ba7dc",
};
